import { isMobile } from '../services/wix-sdk-utils';
import { showModal } from './show-modal';
import { openWixModal } from './open-wix-modal';
import { isInWix } from '../services/is-in-wix';

export const openModal = (type, props, focusOnCloseId) => dispatch => {
  dispatch(showModal(type, props, { focusOnCloseId }));

  if (!isMobile() && isInWix()) {
    dispatch(openWixModal(type, props));
  }
};



// WEBPACK FOOTER //
// ./app/actions/open-modal.js